import request from "@/utils/request";
// roms列表
const getRomsList = (params) =>
  request.post("/laiHi/web/simulator/pageRoms", params);
// 新增或修改rom
const setRom = (params) =>
  request.post("/laiHi/web/simulator/addModifyRom", params);
// 修改rom状态
const editRomStatus = (params) =>
  request.post("/laiHi/web/simulator/modifyRomStatus", params);
// 删除roms
const deleteRoms = (params) =>
  request.post("/laiHi/web/simulator/deleteRoms", params);

// 获取roms详情
const getRomDetail = (id) =>
  request.post(`/laiHi/web/simulator/getRomDetail/${id}`);

export { getRomsList, setRom, editRomStatus, deleteRoms, getRomDetail };
